import { STAGE } from '../app/bdo/enums/stage.enum';
import { AwsAuthConfig } from '../app/bdo/models/AwsAuthConfig';
import { signal, WritableSignal } from '@angular/core';

export class Environment {
  static kameleoon: {
    siteId: string;
    domain: string
  };
  static stage: STAGE = STAGE.Dev;
  static awsAuthConfig: AwsAuthConfig;
  static baseHref: string;
  static apiTags: string;
  static branch: string;
  static local: boolean;
  static config;
  static version: {
    revision: string;
    branch: string;
  };

}

export const sfMap = {
  [STAGE.Dev]: 'https://rheinenergie--dev.sandbox.my.site.com',
  [STAGE.Test]: 'https://service-test.rheinenergie.com',
  [STAGE.Prod]: 'https://service.rheinenergie.com'
};

export class URLs {
  static CONSTRUCTION_SITE_URL = '/baustelle';
  static backend: string = 'http://localhost:8080';

  // default, gets overwritten as soon as config.json has been loaded in main.ts
  static sfLoginUrl: WritableSignal<string> = signal('');
  static sfRegisterUrl: WritableSignal<string> = signal('');
}

export class DatadogConfig {
  static applicationId: string;
  static clientToken: string;
  static appVersion: string;
}

export class ConsentKeys {
  static datadog: string;
  static kameleoon: string;
  static statistics: string;
}

export class LinksMarketingPixelConfig {
  static affiliate: string;
  static tellja: string;
}
